import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import BoardsDropdown from "@Broker/@Modules/util-components/board/boards-dropdown.vue";
import { BOARDS } from "@Broker/@Modules/clients/board/store/board-getters";
import { ADD_TO_BOARD } from "@Broker/@Modules/clients/applications/application/applications-list/store/applications-list-actions";
import { GET_CLIENT_INFORMATION_FOR_TRANSFER } from "@Broker/@Modules/clients/applications/application/store/application-getters";
import { GET_MORTGAGE_CLIENTS, GET_ACTIVITY_CLIENTS, GET_BIRTHDAY_CLIENTS, GET_MORTGAGE_AGENT, GET_BIRTHDAY_AGENT } from "../store/dashboard-getters";
import { CURRENT_USER_USERNAME } from "@Broker/@Modules/main/store/account/account-getters";
import { LOAD_CLIENT_DATA, LOAD_APPLICATION_DATA } from "../../clients/applications/application/store/application-actions";
import ViewOnBoard from "@Broker/@Modules/clients/applications/application/applications-list/components/view-on-board.vue";
import { omit } from "lodash";
import { defineComponent } from "@vue/composition-api";
import NotificationPopover from "@Shared/components/general/notification-popover.vue";
export default defineComponent({
  name: "InformationalTable",
  components: {
    BoardsDropdown,
    ViewOnBoard,
    NotificationPopover
  },
  props: {
    tableName: {
      type: String,
      required: true
    },
    infoType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      columns: ["appId", "firstColumn", "secondColumn", "mortgage", "mortgageType", "date", "coApplicant", "board"],
      options: {
        filterable: false,
        tabbable: false,
        showChildRowToggler: false,
        perPage: 999999,
        headings: {
          appId: this.$t("global.doorr.applicationId"),
          mortgage: this.$t("global.doorr.mortgage"),
          mortgageType: this.$t("global.doorr.mortgageType"),
          firstColumn: this.columnOne,
          secondColumn: this.columnTwo,
          date: this.eventDate,
          board: this.$t("global.doorr.board"),
          coApplicant: this.$t("global.doorr.coapplicant")
        },
        customSorting: {
          date: function (ascending) {
            return function (a, b) {
              const dateAToUse = a.mortgageRenewalDate || a.scheduledDate || a.dateOfBirth;
              const dateBToUse = b.mortgageRenewalDate || b.scheduledDate || b.dateOfBirth;
              let dateA = new Date(dateAToUse);
              let dateB = new Date(dateBToUse);
              if (ascending) return dateA >= dateB ? 1 : -1;
              return dateA <= dateB ? 1 : -1;
            };
          }
        },
        columnsClasses: {
          description: "w-30",
          board: "hidden-heading",
          coApplicant: "hidden-heading",
          mortgageType: this.infoType !== "Mortgage" ? "hidden-heading" : "",
          appId: this.infoType !== "Mortgage" ? "hidden-heading" : "",
          mortgage: this.infoType !== "Mortgage" ? "hidden-heading" : ""
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("AccountStore", [CURRENT_USER_USERNAME])), mapGetters("DashboardStore", [GET_MORTGAGE_AGENT, GET_BIRTHDAY_AGENT])), mapGetters("BoardStore", [BOARDS])), mapGetters("ApplicationStore", [GET_CLIENT_INFORMATION_FOR_TRANSFER])), mapGetters("DashboardStore", [GET_MORTGAGE_CLIENTS, GET_ACTIVITY_CLIENTS, GET_BIRTHDAY_CLIENTS])), {}, {
    getClients() {
      const clients = {
        Mortgage: this.GET_MORTGAGE_CLIENTS,
        Activity: this.GET_ACTIVITY_CLIENTS,
        Birthday: this.GET_BIRTHDAY_CLIENTS
      };
      return clients[this.infoType];
    },
    showBoardOptions() {
      const showBoard = {
        Mortgage: this.GET_MORTGAGE_AGENT === this.CURRENT_USER_USERNAME,
        Activity: true,
        Birthday: this.GET_BIRTHDAY_AGENT === this.CURRENT_USER_USERNAME
      };
      return showBoard[this.infoType];
    }
  }),
  async mounted() {
    var _context;
    if (this.infoType === "Activity") _spliceInstanceProperty(_context = this.columns).call(_context, 3, 0, "description");
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("ApplicationsListStore", [ADD_TO_BOARD])), mapActions("ApplicationStore", [LOAD_CLIENT_DATA, LOAD_APPLICATION_DATA])), {}, {
    eventDate() {
      const text = {
        Mortgage: this.$t("global.doorr.renewalDate"),
        Activity: this.$t("dashboard.informationalCards.nextActionDate"),
        Birthday: this.$t("dashboard.informationalCards.birthDate")
      };
      return text[this.infoType];
    },
    columnOne() {
      return this.infoType === "Mortgage" ? this.$t("global.words.name") : this.$t("account.givenName");
    },
    columnTwo() {
      return this.infoType === "Mortgage" ? this.$t("dashboard.informationalCards.property") : this.$t("account.familyName");
    },
    columnTwoText(row) {
      return this.infoType === "Mortgage" ? row.propertyAddress : row.familyName;
    },
    dateText(row) {
      const date = {
        Mortgage: row.mortgageRenewalDate,
        Activity: row.scheduledDate,
        Birthday: row.dateOfBirth
      };
      return moment(date[this.infoType]).format("MMM Do, YYYY");
    },
    async addClient(row, boardId, index) {
      const button = $(this.$refs[`addToBoardDropdown-${index}`]);
      try {
        button.toggleClass("dropdown-toggle");
        button.animateButton().animate("start");
        await this.LOAD_CLIENT_DATA({
          agentUsername: this.CURRENT_USER_USERNAME,
          clientUsername: row.clientUsername,
          applicationId: row.applicationId,
          clientProfileId: row.clientProfileId
        });
        await this.LOAD_APPLICATION_DATA({
          agentUsername: this.CURRENT_USER_USERNAME,
          clientUsername: row.clientUsername,
          applicationId: row.applicationId,
          clientProfileId: row.clientProfileId
        });
        const clientDetails = this.clientInformation(row);
        await this.ADD_TO_BOARD({
          clientDetails,
          boardId
        });
        button.animateButton().animate("finish", "success");
      } catch (e) {
        button.animateButton().animate("finish", "failed");
      }
      button.toggleClass("dropdown-toggle");
    },
    clientInformation(row) {
      return this.GET_CLIENT_INFORMATION_FOR_TRANSFER({
        clientUsername: row.clientUsername,
        applicationId: row.applicationId
      });
    },
    getApplicationLink(row) {
      return {
        name: "application",
        params: {
          clientUsername: row.clientUsername,
          agentUsername: row.agentUsername,
          applicationId: row.applicationId
        }
      };
    },
    hideModal() {
      this.$emit("hide");
    },
    isCoapplicantBirthday(mainApp) {
      return this.infoType === "Birthday" && mainApp === false;
    },
    formattedProfileData(row) {
      if (row.clientProfileId) {
        return [{
          id: row.clientProfileId,
          boardId: row.boardId
        }];
      }
      const profiles = row.clientProfiles || [];
      return _mapInstanceProperty(profiles).call(profiles, profile => _objectSpread({
        id: profile.clientProfileId
      }, omit(profile, "clientProfileId")));
    },
    shouldShowViewOnBoard(row) {
      var _row$clientProfiles;
      return ((_row$clientProfiles = row.clientProfiles) == null ? void 0 : _row$clientProfiles.length) || row.clientProfileId;
    }
  })
});